export default __webpack_public_path__ + "static/media/modal-flower.ea27edb8.png";